
const themes = {
  dark:{
    background:'#333',
    color:'white',
  },
  light:{
    background:'#eee',
    color:'black',
  }
}

export default function Circle({onClick, background, theme="light",
  dim=15,
  htmlProps

}){



  if( theme === "dark" ){
  }

  return (
    <div {...htmlProps} onClick={e => {
      e.stopPropagation();
      onClick && onClick(e);
      }}
      class="hoverable" style={{
        pointerEvents:'auto',
        position:'absolute', 
        width:dim, height:dim, 
        top:-dim/2,
        right:-dim/2,
        borderRadius:dim,
        cursor:'pointer',
        lineHeight:1,
        fontSize:(dim-2),
        fontWeight:'bold',
        textAlign:'center',
        ...themes[theme],
        zIndex:3,
      }}>
    ×
  </div>)
}
